<template>
  <div class="bg-gray-100 py-24 sm:py-32 relative">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <h2 class="text-center text-3xl font-bold text-gray-900 mb-12">Opinie naszych klientów</h2>

      <div class="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
        <!-- Opinia 1 -->
        <div class="bg-white p-6 rounded-lg shadow-lg text-gray-900 relative">
          <div class="absolute top-[0px] left-[0px] flex flex-col">
            <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
            <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
          </div>
          <p class="text-lg font-medium">"Każdy członek zespołu, z którym miałam kontakt, był ekspertem w swojej dziedzinie i wykazywał się ogromnym zaangażowaniem. Dzięki nim budowa naszego domu była bezstresowa i przyjemna."</p>
          <div class="mt-4 text-[#E67E22] text-xl font-bold">★★★★★</div>
          <p class="mt-2 text-sm text-gray-600">Anna Mazur</p>
          <div class="absolute bottom-[0px] right-[0px] flex flex-col items-end">
            <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
            <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
          </div>
        </div>

        <!-- Opinia 2 -->
        <div class="bg-white p-6 rounded-lg shadow-lg text-gray-900 relative">
          <div class="absolute top-[0px] left-[0px] flex flex-col">
            <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
            <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
          </div>
          <p class="text-lg font-medium">"Proces realizacji deweloperskiej przebiegł niezwykle szybko, sprawnie i bezproblemowo, co pozwoliło mi bez zbędnych opóźnień cieszyć się gotowym mieszkaniem."</p>
          <div class="mt-4 text-[#E67E22] text-xl font-bold">★★★★★</div>
          <p class="mt-2 text-sm text-gray-600">Sebastian Matejko</p>
          <div class="absolute bottom-[0px] right-[0px] flex flex-col items-end">
            <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
            <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
          </div>
        </div>

        <!-- Opinia 3 -->
        <div class="bg-white p-6 rounded-lg shadow-lg text-gray-900 relative">
          <div class="absolute top-[0px] left-[0px] flex flex-col">
            <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
            <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
          </div>
          <p class="text-lg font-medium">"Uwielbiam proste, minimalistyczne wnętrza, ale trudno mi było samodzielnie je zaprojektować. Architekt wnętrz z ProjectSpot stworzył projekt, który idealnie oddaje mój styl życia. Współpraca była płynna, a realizacja szybka. Jestem zachwycona!"</p>
          <div class="mt-4 text-[#E67E22] text-xl font-bold">★★★★★</div>
          <p class="mt-2 text-sm text-gray-600">Adrianna Stańczak</p>
          <div class="absolute bottom-[0px] right-[0px] flex flex-col items-end">
            <div class="w-0.5 h-4 bg-[#E9A53D]"></div>
            <div class="w-4 h-0.5 bg-[#E9A53D]"></div>
          </div>
        </div>
      </div>

      <!-- Statystyki -->
      <div class="mt-16 text-center">
        <h3 class="text-2xl font-bold text-gray-900 mb-8">Nasze osiągnięcia</h3>
        <div class="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
          <!-- Statystyka 1 -->
          <div class="mx-auto flex flex-col items-center gap-y-4">
            <dt class="text-xl font-medium text-gray-700">Średnia ocena Google</dt>
            <dd class="text-4xl font-medium tracking-tight text-gray-900 sm:text-5xl">5/5</dd>
            <div class="w-16 h-[3px] bg-[#E9A53D] mx-auto mt-4"></div>
          </div>

          <!-- Statystyka 2 -->
          <div class="mx-auto flex flex-col items-center gap-y-4">
            <dt class="text-xl font-medium text-gray-700">Zadowoleni klienci</dt>
            <dd class="text-4xl font-medium tracking-tight text-gray-900 sm:text-5xl">100%</dd>
            <div class="w-16 h-[3px] bg-[#E9A53D] mx-auto mt-4"></div>
          </div>

          <!-- Statystyka 3 -->
          <div class="mx-auto flex flex-col items-center gap-y-4">
            <dt class="text-xl font-medium text-gray-700">Liczba opinii</dt>
            <dd class="text-4xl font-medium tracking-tight text-gray-900 sm:text-5xl">50+</dd>
            <div class="w-16 h-[3px] bg-[#E9A53D] mx-auto mt-4"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bg-white {
  background-color: #ffffff;
}

.text-gray-600 {
  color: #4b5563;
}

.text-gray-900 {
  color: #111827;
}
</style>

<script setup lang="ts">
</script>
